<template>
  <!-- 字体样式设置 -->
  <div class="fontStyleSet">
    <!-- 左侧-目录 -->
    <div class="leftSlider">
      <fontLeft ref="fontSetLeft" @setCurrentFont="setCurrentFont"></fontLeft>
    </div>

    <!-- 右侧-表格展示 -->
    <div class="rightSlider">
      <fontRight ref="fontSetRight" @refreshLeft="refreshLeft"></fontRight>
    </div>
  </div>
</template>

<script>
import fontLeft from "./fontSetComponent/fontLeft.vue";
import fontRight from "./fontSetComponent/fontRight.vue";

export default {
  name: "FontStyleSet",
  components: { fontLeft, fontRight },
  data() {
    return {};
  },
  methods: {
    // 左侧设置font，传给右侧
    setCurrentFont(font) {
      this.$refs.fontSetRight.fontStyleId = font.fontStyleId;
      this.$refs.fontSetRight.fontStyleName = font.fontStyleName;
      this.$refs.fontSetRight.isReplaceReinforcedSymbol = font.isReplaceReinforcedSymbol;
      this.$refs.fontSetRight.isClearFontStyle = font.isClearFontStyle;
    },
    // 左侧刷新数据
    refreshLeft() {
      this.$refs.fontSetLeft.getFontLeftData();
    }
  }
};
</script>

<style lang='scss' scoped>
.fontStyleSet {
  width: 100%;
  height: 100%;
  padding: 5px 0;
  background-color: #ffffff;

  display: flex;

  .leftSlider {
    width: 250px;
    height: 100%;
    border-right: 1px solid #e5e8f1;
  }

  .rightSlider {
    width: calc(100% - 250px);
    height: 100%;
  }
}
</style>
